import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _ShelfInventory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable } from "../../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";

type StoreBean = {
    IDStore?: number,
    [key: string]: unknown;
}

interface ShelfInventoryComponent {
    Store: StoreBean;
    _onChange?: Function;
    storeModify?: boolean;
}

export const ShelfInventory = ({ Store, _onChange, storeModify = false }: ShelfInventoryComponent) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, isMissing, isRequired, validateForm } = useDataBean(_ShelfInventory);
    const paginador = usePaginator();

    const [regex, setRegex] = useState<string>("");
    const [selectedStore, setSelectedStore] = useState<StoreBean>(Store ?? {});

    const currentStoreID = storeModify ? selectedStore?.IDStore : Store?.IDStore;

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Estatería/Ubicacion Física", MODAL_SM);

    useEffect(() => {
        addRequiredFields(["Name"])
    }, [])

    useEffect(() => {
        setSelectedStore(Store ?? {});
    }, [Store?.IDStore])

    useEffect(() => {
        if (currentStoreID) {
            getLista();
        } else {
            setLista([]);
            setBean({});
            paginador.setPages(0);
            paginador.setRecords(0);
        }
    }, [currentStoreID])

    const getLista = () => {
        if (!currentStoreID) {
            toast.error("Debe seleccionar un almacen");
            return;
        }

        instance.getShelfInventoryCatalog(currentStoreID, regex, paginador.page, 15).then(
            (resp) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setBean({});
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDShelfInventory', visible: true },
        { title: 'Código Estante', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const create = () => {
        if (!currentStoreID) {
            toast.error("Debe seleccionar un almacen");
            return;
        }

        setBean({
            IDStore: currentStoreID,
        });
        modal.open("Agregar Tipo de Actividades")
    }

    const deleteItem = () => {
        instance.deleteShelfInventory(bean.IDShelfInventory).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateShelfInventory({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar tipo ${bean.WorkActivityTypeName}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e) => {
        const value = { ...e, IDStore: e.IDStore ?? currentStoreID };
        setBean(value);
        _onChange?.(value)
    }

    const changeStore = (store: StoreBean) => {
        const storeChanged = store?.IDStore !== selectedStore?.IDStore;
        setSelectedStore(store);
        if (storeChanged) {
            setLista([]);
            setBean({});
            _onChange?.({});
        }
    }

    return (
        <>
            <div className="row">
                {storeModify &&
                    <div className="col-md-6">
                        <SelectStoreEditor label="Almacen" idSelector={selectedStore?.IDStore} onChange={changeStore} />
                    </div>
                }
                <div className="col-md-6">
                    <label >Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                </div>
                <div className="col-md-6">
                    <BasicButton icon="ri-seach-line" useMargin eventClick={() => { getLista(); }}>Buscar</BasicButton>
                </div>
                <BasicTable body={lista} head={head} rowSet={setValue} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                <div className="row">
                    <div className="col-md-12">
                        <label className={`${isMissing('Name') ? 'has-error' : ''}`}>Código Estante {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                    </div>

                    <div className="col-md-12">
                        <label>Descripción del tipo de Actividad</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                    </div>
                </div>
            </Modal>

            <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                <strong>Eliminar Estatería/Ubicacion Física {bean.Name}</strong>
            </ModalConfirm>
        </>
    )
}
